/** Route of the one-time "your permit test is three tests" map screen. */
export const COURSE_MAP_PATH = "/course-map";

/** Route of the in-course exam runner (`?exam=<id>&next=<path>`). */
export const SECTION_EXAM_PATH = "/section-exam";

/** Route of the "Section N of 3 done" interstitial (`?section=<id>&next=<path>`). */
export const SECTION_DONE_PATH = "/section-done";

/** Query param naming the section just closed. */
export const SECTION_DONE_SECTION_PARAM = "section";

/** Query param naming the section exam to run. */
export const SECTION_EXAM_PARAM = "exam";

/**
 * Query param carrying where the student goes after the exam (or after
 * skipping it): the lesson they were heading to, the next exam in a chain,
 * the course list, or the course-complete success plan.
 */
export const SECTION_EXAM_RETURN_PARAM = "next";

/**
 * localStorage key prefix for the per-student "map already shown" mark.
 * Suffixed with `:{uid}` so two students on one device never share it.
 */
export const COURSE_MAP_SEEN_KEY_PREFIX = "emerge.sectionExams.courseMapSeen";

/** localStorage key prefix for the per-student, per-exam "skipped" mark. */
export const SECTION_EXAM_SKIPPED_KEY_PREFIX = "emerge.sectionExams.skipped";

/** Where the course-complete redirect has always gone. */
export const COURSE_COMPLETE_PATH = "/theory-exam/success-plan";

/** The CDL course list, used as the exit of a retake started from it. */
export const CDL_COURSE_PATH = "/courses/cdl";

/** DMV pass mark for every CLP knowledge test. */
export const DMV_PASS_FRACTION = 0.8;
